<script lang="ts" setup>
import FastPickupIcon from "@/components/icons/FastPickupIcon.vue";
import OfferMonthDetail from "@/models/OfferMonthDetail";
import Product from "@/models/Product";

const props = defineProps<{ product: Product }>();

const hasMsi = !!props.product.offer_months.find(
  (month) => month.interest_percent === 0 && month.months > 1,
);
let bestInterestMonth: OfferMonthDetail;
props.product.offer_months.forEach((month) => {
  if (
    month.interest_percent > 0 &&
    month.months > 1 &&
    (!bestInterestMonth || month.months > bestInterestMonth.months)
  ) {
    bestInterestMonth = month;
  }
});
const hasFastPickup = props.product.stock_stores > 0;
</script>
<template>
  <div v-if="hasMsi || hasFastPickup || bestInterestMonth" class="d-flex gap-2">
    <span
      v-if="hasFastPickup"
      class="badge rounded-pill text-bg-light d-flex align-items-center py-1"
    >
      <fast-pickup-icon />
      <span class="fw-bold small ms-1">RECOGE EN 15 MIN</span>
    </span>
    <span
      v-if="hasMsi"
      class="badge rounded-pill text-bg-light d-flex align-items-center py-1"
    >
      <i class="bi bi-credit-card-fill fs-6 text-info"></i>
      <span class="fw-bold small ms-1">CON MSI</span>
    </span>
    <span
      v-if="bestInterestMonth"
      class="badge rounded-pill text-bg-light d-flex align-items-center py-1"
    >
      <i class="bi bi-calendar-event-fill fs-6 text-secondary"></i>
      <span class="fw-bold small ms-1"
        >{{ bestInterestMonth.months }} PAGOS FIJOS</span
      >
    </span>
  </div>
</template>
